/**
 * My Insights Routes
 * legacy app: canActivate: [AuthGuard, VendorRoleGuard]
 */

import { lazy } from 'react';
import { RouteConfig } from '../../types';

const MyInsights = lazy(() => import('@src/apps/MyInsights/MyInsights-connect'));

export const myInsightsRoutes: RouteConfig[] = [
  {
    path: 'myinsights',
    component: MyInsights,
    guards: ['auth', 'vendor'],
    data: {
      title: 'My Insights',
      breadcrumb: 'My Insights',
      preload: false,
      delay: true,
    },
  },
];

